import { DAY_NIGHT_CYCLE, SKY_GRADIENTS } from "./constants";
import type { DayNightCycle, SkyColors } from "./types";

export function initializeDayNightCycle(): DayNightCycle {
  return { gameTime: 0, timeOfDay: 0.25 };
}

export function updateDayNightCycle(dayNight: DayNightCycle, dt: number): void {
  dayNight.gameTime += dt;
  dayNight.timeOfDay = (dayNight.gameTime / DAY_NIGHT_CYCLE.CYCLE_DURATION) % 1;
}

export function interpolateColor(
  color1: readonly [number, number, number],
  color2: readonly [number, number, number],
  t: number,
): [number, number, number] {
  return [
    Math.round(color1[0] + (color2[0] - color1[0]) * t),
    Math.round(color1[1] + (color2[1] - color1[1]) * t),
    Math.round(color1[2] + (color2[2] - color1[2]) * t),
  ] as [number, number, number];
}

export function getCurrentSkyColors(timeOfDay: number): SkyColors {
  if (timeOfDay < 0.25) {
    const t = timeOfDay / 0.25;
    return {
      top: interpolateColor(SKY_GRADIENTS.DAWN.TOP, SKY_GRADIENTS.DAY.TOP, t),
      middle: interpolateColor(
        SKY_GRADIENTS.DAWN.MIDDLE,
        SKY_GRADIENTS.DAY.MIDDLE,
        t,
      ),
      bottom: interpolateColor(
        SKY_GRADIENTS.DAWN.BOTTOM,
        SKY_GRADIENTS.DAY.BOTTOM,
        t,
      ),
    };
  } else if (timeOfDay < 0.5) {
    const t = (timeOfDay - 0.25) / 0.25;
    return {
      top: interpolateColor(SKY_GRADIENTS.DAY.TOP, SKY_GRADIENTS.DUSK.TOP, t),
      middle: interpolateColor(
        SKY_GRADIENTS.DAY.MIDDLE,
        SKY_GRADIENTS.DUSK.MIDDLE,
        t,
      ),
      bottom: interpolateColor(
        SKY_GRADIENTS.DAY.BOTTOM,
        SKY_GRADIENTS.DUSK.BOTTOM,
        t,
      ),
    };
  } else if (timeOfDay < 0.75) {
    const t = (timeOfDay - 0.5) / 0.25;
    return {
      top: interpolateColor(SKY_GRADIENTS.DUSK.TOP, SKY_GRADIENTS.NIGHT.TOP, t),
      middle: interpolateColor(
        SKY_GRADIENTS.DUSK.MIDDLE,
        SKY_GRADIENTS.NIGHT.MIDDLE,
        t,
      ),
      bottom: interpolateColor(
        SKY_GRADIENTS.DUSK.BOTTOM,
        SKY_GRADIENTS.NIGHT.BOTTOM,
        t,
      ),
    };
  } else {
    const t = (timeOfDay - 0.75) / 0.25;
    return {
      top: interpolateColor(SKY_GRADIENTS.NIGHT.TOP, SKY_GRADIENTS.DAWN.TOP, t),
      middle: interpolateColor(
        SKY_GRADIENTS.NIGHT.MIDDLE,
        SKY_GRADIENTS.DAWN.MIDDLE,
        t,
      ),
      bottom: interpolateColor(
        SKY_GRADIENTS.NIGHT.BOTTOM,
        SKY_GRADIENTS.DAWN.BOTTOM,
        t,
      ),
    };
  }
}
